ACC.slider = {
    _autoload: ["init"],

    init: function () {
        const sliders = document.querySelectorAll('.splide');
        sliders.forEach(slider => {
            let hasOneElement = slider.dataset.size == 1;

            let splide = new Splide(slider, {
                type: 'loop',
                interval: hasOneElement && slider.dataset.speed ? parseInt(slider.dataset.speed, 10) : 5000,
                focus: 'center',
                autoplay: !hasOneElement,
                rewind: true,
                arrows: slider.dataset.arrows?.toLowerCase() === 'true' && !hasOneElement,
                pagination: !hasOneElement && slider.dataset.pagination?.toLowerCase() === 'true',
                drag: !hasOneElement
            }).mount();

            splide.on('moved', () => {
                ACC.slider.viewEventdataLayer(slider);
            });

            splide.on('click', () => {
                let banner_name = slider.querySelector('.splide__list .is-active')?.dataset.bannerName || '';
                ACC.track.homePageSliderBannerClickEvent(banner_name);
            });

            ACC.slider.viewEventdataLayer(slider);
        });
    },

    viewEventdataLayer: function (slider) {
        let banner_name = slider.querySelector('.splide__list .is-active')?.dataset.bannerName || '';
        if (banner_name) {
            ACC.track.homePageSliderBannerViewEvent(banner_name);
        }
    }
}
